import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetNotifications = (filter, userId) => {
  const data = useQuery(
    ["notificationsList", filter, userId],
    () =>
      axiosClient.get(
        `/Notification/GetNotification?userId=${userId}&notificationType=${filter}`
      ),
    {
      refetchInterval: 5 * 60 * 1000, 
      refetchIntervalInBackground: true,
    }
  );

  return data;
};
export default useGetNotifications;